<div class="vc-field">
   <label
      *ngIf="label"
      class="vc-label">
      <span
         *ngIf="infoTooltip"
         class="infoTooltip"
         [pTooltip]="infoTooltip"
         tooltipStyleClass="pims-tooltip">
         i
      </span>
      {{ label }}
      <span
         *ngIf="required"
         class="required-asterisk">
         *
      </span>
   </label>

   @if (yesno) {
      <div [class.is-inline]="isInline">
         <div class="article-feedback-container">
            <div class="article-feedback-wrapper">
               <span *ngFor="let o of options">
                  <input
                     id="{{ (groupName || label) + o.value }}"
                     [name]="groupName || label || 'vc-radio'"
                     [disabled]="disabled"
                     [value]="o.value"
                     [required]="required"
                     [(ngModel)]="value"
                     (ngModelChange)="onChange($event)"
                     (onBlur)="onTouched()"
                     type="radio"
                     #ngModelCtrl="ngModel"
                     class="input"
                     [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)" />
                  <label
                     for="{{ (groupName || label) + o.value }}"
                     class="article-feedback"
                     (click)="!disabled && onChange(o.value)">
                     {{ o.label }}
                  </label>
               </span>
            </div>
         </div>
      </div>
   } @else if (radiobutton) {
      <div class="button-group">
         <span *ngFor="let o of options">
            <input
               id="{{ (groupName || label) + o.value }}"
               [name]="groupName || label || 'vc-radio'"
               [disabled]="disabled"
               [value]="o.value"
               [required]="required"
               [(ngModel)]="value"
               (ngModelChange)="onChange($event)"
               (onBlur)="onTouched()"
               type="radio"
               #ngModelCtrl="ngModel"
               class="input"
               [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)" />
            <label
               for="{{ (groupName || label) + o.value }}"
               class="article-feedback"
               (click)="!disabled && onChange(o.value)">
               {{ o.label }}
            </label>
         </span>
      </div>
   } @else {
      <div
         class="vc-radio-group"
         [class.column]="direction === 'column'">
         <div
            class="vc-radio"
            *ngFor="let o of options">
            <p-radioButton
               inputId="{{ (groupName || label) + o.value }}"
               [name]="groupName || label || 'vc-radio'"
               [disabled]="disabled"
               [value]="o.value"
               [required]="required"
               [(ngModel)]="value"
               (ngModelChange)="onChange($event)"
               (onBlur)="onTouched()"
               #ngModelCtrl="ngModel"
               [class.invalid]="required && ngModelCtrl.invalid && (ngModelCtrl.touched || ngModelCtrl.dirty)"></p-radioButton>
            <label
               for="{{ (groupName || label) + o.value }}"
               class="vc-inline-label"
               (click)="!disabled && onChange(o.value)">
               {{ o.label }}
            </label>
         </div>
      </div>
   }
</div>
